var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.277,
    height: 4.695,
    viewBox: "0 0 8.277 4.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-down",
    d: "M11.852,192h7.163a.556.556,0,0,1,.393.949l-3.58,3.583a.558.558,0,0,1-.788,0l-3.58-3.583A.556.556,0,0,1,11.852,192Z",
    transform: "translate(-11.295 -192)",
    fill: "#44454a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.9b0575955b264909968b9720ed4b6148.svg";
export { ForwardRef as ReactComponent };